import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import { DashboardHelper } from '../../../../services/dashboard.service';
import { INextgenApplicationModel, NextgenApplicationModel } from '../../../../models/child-application/nextgen-application.model';
import { ExternalLinkStore } from '../../../../services/stores/external-link.store';
import { ApplicationStore } from '../../../../services/stores/application.store';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as AppConstants from '../../../../modules/catch-core/data/constants/app.constants';
import { isFranklyProductType } from '../../../../modules/catch-core/data/helpers/product-type.helper';
import { MaterialModule } from '../../../../modules/catch-core/third-party/material/material.module';

export class ToolbarAppMenuAppIconModel {
  url: string = '';
  label: string = '';
  description: string = '';
  appModel: INextgenApplicationModel | undefined;
  base64String: SafeResourceUrl | undefined;

  constructor(url: string, base64String: SafeResourceUrl | undefined, label: string, description: string, appModel: INextgenApplicationModel | undefined) {
    this.url = url;
    this.appModel = appModel;
    this.label = label;
    this.description = description;
    this.base64String = base64String;
  }
}
@Component({
  selector: 'app-toolbar-app-menu',
  templateUrl: './toolbar-app-menu.component.html',
  styleUrls: ['./toolbar-app-menu.component.css'],
  standalone: false,
})
export class ToolbarAppMenuComponent extends BaseComponent implements OnInit {
  appIconList: ToolbarAppMenuAppIconModel[] = [];

  constructor(
    private externalLinkStore: ExternalLinkStore,
    private appStore: ApplicationStore,
    private dashboardHelper: DashboardHelper,
    private domSanitizer: DomSanitizer,
  ) {
    super();
  }

  ngOnInit() {
    this.appIconList = [];

    // When external links are updated, refresh icons which is loaded from $firstExternalLink
    this.subscribers.externalLinks = this.externalLinkStore.$externalLinks.subscribe((res) => {
      this.loadFirstExternalLinks();
    });
  }

  private loadFirstExternalLinks(): void {
    if (this.subscribers.firstExternalLink) {
      this.subscribers.firstExternalLink.unsubscribe();
    }
    this.subscribers.firstExternalLink = this.externalLinkStore.$firstExternalLink.subscribe((g) => {
      if (g) {
        let externalLinks = g.externalLinks;

        // remove hidden links
        // externalLinks = externalLinks.filter(e => (e.productType === 'Enterprise Tester') || (e.showInDashBoard && e.active));

        externalLinks = externalLinks.filter((e: any) => (!e.isNextGenMenu || isFranklyProductType(e.productType)) && e.showInDashBoard && e.active);

        if (this.subscribers.appstore) {
          this.subscribers.appstore.unsubscribe();
        }

        this.subscribers.appstore = this.appStore.$applications.subscribe((a) => {
          if (a) {
            this.buildAppIconList(this.dashboardHelper.buildSortedApplicationArray(externalLinks));
          }
        });
      }
    });
  }

  private buildAppIconList(appList: INextgenApplicationModel[]): void {
    const catchHubIconModel = new NextgenApplicationModel(AppConstants.CATCH_HUB, AppConstants.CATCH_HUB);
    this.appIconList = [new ToolbarAppMenuAppIconModel('assets/images/catch_hub_icon_green_onclear.svg', undefined, catchHubIconModel.name, catchHubIconModel.description, catchHubIconModel)];
    // console.log(appList);
    appList.forEach((app) => {
      if (app.name.toLowerCase() === AppConstants.CATCH_INTERNAL_APP_SMARTPLANNER_LOWER) {
        this.addAppIconToAppIconList('assets/images/smartplanner_icon_green_onclear.svg', app);
      } else if (app.name.toLowerCase() === AppConstants.MAP) {
        this.addAppIconToAppIconList('assets/images/smartmap_icon_green_onclear.svg', app);
      } else if (app.name.toLowerCase() === AppConstants.DO) {
        this.addAppIconToAppIconList('assets/images/justtest_icon_green_onclear.svg', app);
      } else if (app.name.toLowerCase() === AppConstants.FRANKLY) {
        this.addAppIconToAppIconList('assets/images/frankly.png', app);
      } else if (isFranklyProductType(app.name) || app.name.toLowerCase() === AppConstants.CLASSIC) {
        this.addAppIconToAppIconList('assets/images/enterprise_tester.png', app);
      } else if (app.name.toLowerCase() === AppConstants.JIRA) {
        this.addAppIconToAppIconList('assets/images/jira.png', app);
      } else if (app.productType.toLocaleLowerCase() === AppConstants.OTHER && app.icon && app.showInMenu) {
        this.addAppIconToAppIconList(app.icon.attachment, app);
      }
    });
  }

  private addAppIconToAppIconList(iconUrl: string, appModel: INextgenApplicationModel): void {
    if (appModel.name.toLowerCase() === AppConstants.FRANKLY) {
      this.appIconList.push(new ToolbarAppMenuAppIconModel(iconUrl, undefined, 'Frankly', appModel.description, appModel));
    } else if (isFranklyProductType(appModel.name) || appModel.name.toLowerCase() === AppConstants.CLASSIC) {
      // Legacy Enterprise Tester / Classic — keep its own name so the label matches the icon.
      this.appIconList.push(new ToolbarAppMenuAppIconModel(iconUrl, undefined, appModel.name, appModel.description, appModel));
    } else if (appModel.name.toLowerCase() === AppConstants.CATCH_INTERNAL_APP_SMARTPLANNER_LOWER) {
      const smartPlannerIconUrl = 'assets/images/SmartPlanner Icon Grey.png';
      this.appIconList.push(new ToolbarAppMenuAppIconModel(smartPlannerIconUrl, undefined, AppConstants.CATCH_INTERNAL_APP_SMART_PLANNER_LOWER, appModel.description, appModel));
    } else if (appModel.name.toLowerCase() === AppConstants.JIRA) {
      this.appIconList.push(new ToolbarAppMenuAppIconModel(iconUrl, undefined, AppConstants.JIRA, appModel.description, appModel));
    } else {
      // Custom-uploaded icon (productType === 'Other'): iconUrl is base64 attachment data, wrap as data URL.
      const safeIconUrl = iconUrl ? this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + iconUrl) : undefined;
      this.appIconList.push(new ToolbarAppMenuAppIconModel('', safeIconUrl, appModel.name, appModel.description, appModel));
    }
  }
}
